module.exports = __webpack_public_path__ + "img/Biamj.61f07837.svg";